import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, fmtError } from "@/lib/api";
import { PublicHeader } from "@/components/layout/Layout";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const [msg, setMsg] = useState("Vérification en cours…");
  useEffect(() => {
    (async () => {
      try { await api.post("/auth/verify-email", null, { params: { token: sp.get("token") } }); setMsg("Votre e-mail est vérifié. Vous pouvez vous connecter."); }
      catch (err) { setMsg(fmtError(err)); }
    })();
  }, [sp]);
  return (
    <div className="min-h-screen bg-white">
      <PublicHeader />
      <div className="max-w-md mx-auto px-4 py-10">
        <h1 className="text-2xl font-semibold text-[#1F2933]">Vérification e-mail</h1>
        <p className="mt-4 text-sm text-[#1F2933]" data-testid="verify-msg">{msg}</p>
        <Link to="/connexion" className="btn-primary mt-6" data-testid="verify-login-link">Se connecter</Link>
      </div>
    </div>
  );
}
